import type { ModuleDefinition } from "../types";
import { FRONTDESK_MANAGE, FRONTDESK_VIEW } from "./permissions";
// The sidebar needs these labels before any lazy Front desk screen opens.
import "./messages";

const screens = () => import("./screens");

export const frontdeskModule: ModuleDefinition = {
  id: "frontdesk",
  labelKey: "module.frontdesk",
  nav: [
    { id: "desk", labelKey: "frontdesk.nav.desk", to: "/frontdesk", icon: "table", permission: FRONTDESK_VIEW, end: true },
    { id: "desks", labelKey: "frontdesk.nav.desks", to: "/frontdesk/desks", icon: "building", permission: FRONTDESK_MANAGE },
  ],
  routes: [
    { path: "frontdesk", permission: FRONTDESK_VIEW, load: async () => ({ default: (await screens()).FrontdeskPage }) },
    { path: "frontdesk/desks", permission: FRONTDESK_MANAGE, load: async () => ({ default: (await screens()).DesksPage }) },
    { path: "frontdesk/layout/:deskId", permission: FRONTDESK_MANAGE, load: async () => ({ default: (await screens()).LayoutPage }) },
  ],
};
